// src/pages/AboutUs.jsx
import React from 'react';
import { Box, Button, Paper, Typography, Container, Divider } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Meta from '../../components/common/Meta';

function AboutUs() {
  return (
    <>
      <Meta page="about" />

      <Box
        component="main"
        sx={{
          minHeight: '100vh',
          py: 4,
        }}
      >
        <Container maxWidth="lg">
          <Paper
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              p: 4,
            }}
          >
            {/* Page Title */}
            <Typography variant="h3" component="h1" gutterBottom>
              About Noor-un-Nikah
            </Typography>

            {/* Introduction */}
            <Typography variant="body1" paragraph>
              <strong>Noor-un-Nikah—Sacred Bonds, Blessed Beginnings</strong>
            </Typography>

            <Typography variant="body1" paragraph>
              A <strong>Carvan-e-Islam</strong> initiative, <strong>Noor-un-Nikah</strong> is a dedicated platform for facilitating meaningful, halal connections leading to blessed marriages. We operate with the noble intention of serving the community by providing a respectful and Islamic environment for individuals and families seeking life partners.
            </Typography>

            <Typography variant="body1" paragraph>
              Our platform publishes <strong>verified profiles</strong> of eligible individuals, empowering users to conduct <strong>personal verification</strong> and establish <strong>sincere relationships</strong> based on mutual respect, shared values, and divine intention.
            </Typography>

            {/* Divider */}
            <Divider sx={{ my: 5 }} />

            {/* Our Vision */}
            <Typography variant="h4" component="h2" gutterBottom>
              Our Vision
            </Typography>

            <Typography variant="body1" paragraph>
              We envision a community where Muslim marriages are built upon <strong>Islamic principles</strong>, <strong>mutual respect</strong>, and <strong>spiritual harmony</strong>. Our aim is to illuminate the path to matrimony with sincerity, modesty, and divine blessing, fostering unions that strengthen families and society.
            </Typography>

            {/* Our Mission */}
            <Typography variant="h4" component="h2" gutterBottom sx={{ mt: 4 }}>
              Our Mission
            </Typography>

            <Typography variant="body1" paragraph component="div">
              <Box component="ul" sx={{ pl: 2, m: 0 }}>
                <li>Provide a <strong>verified and secure platform</strong> for halal matchmaking</li>
                <li>Uphold <strong>Islamic values</strong> of modesty, honesty, and integrity in all interactions</li>
                <li>Facilitate <strong>traditional matchmaking</strong> with modern convenience</li>
                <li>Support families in finding <strong>compatible partnerships</strong> based on shared faith and values</li>
                <li>Maintain <strong>confidentiality and respect</strong> for all users' privacy</li>
                <li>Serve as a <strong>trusted intermediary</strong> while encouraging personal due diligence</li>
              </Box>
            </Typography>

            {/* Our Process */}
            <Typography variant="h4" component="h2" gutterBottom sx={{ mt: 4 }}>
              Our Process
            </Typography>

            <Typography variant="body1" paragraph component="div">
              <Box component="ol" sx={{ pl: 2, m: 0 }}>
                <li><strong>Profile Verification:</strong> We authenticate user information for credibility</li>
                <li><strong>Profile Publishing:</strong> Verified profiles are made available on our platform</li>
                <li><strong>Personal Verification:</strong> Users conduct their own verification and background checks</li>
                <li><strong>Respectful Introduction:</strong> We facilitate initial contact with Islamic etiquette</li>
                <li><strong>Family Involvement:</strong> Encouraging family participation in the process</li>
                <li><strong>Continued Support:</strong> Guidance throughout the relationship development</li>
              </Box>
            </Typography>

            {/* Why Choose Us */}
            <Typography variant="h4" component="h2" gutterBottom sx={{ mt: 4 }}>
              Why Choose Noor-un-Nikah?
            </Typography>

            <Typography variant="body1" paragraph component="div">
              <Box component="ul" sx={{ pl: 2, m: 0 }}>
                <li><strong>Islamic Foundation:</strong> Operating with Islamic principles and values</li>
                <li><strong>Verified Profiles:</strong> Authentic profiles with basic verification</li>
                <li><strong>Respectful Environment:</strong> Maintaining modesty and Islamic etiquette</li>
                <li><strong>Community Trust:</strong> Backed by Carvan-e-Islam Welfare Trust</li>
                <li><strong>Personal Control:</strong> Users conduct their own verification and decision-making</li>
                <li><strong>Traditional Values:</strong> Preserving cultural and religious traditions in matchmaking</li>
                <li><strong>Confidential Service:</strong> Protecting user privacy and personal information</li>
                <li><strong>Non-Commercial Intent:</strong> Serving the community with sincere purpose</li>
              </Box>
            </Typography>

            {/* Final Message */}
            <Typography variant="body1" paragraph sx={{ mt: 4, fontStyle: 'italic', textAlign: 'center' }}>
              "Choose <strong>Noor-un-Nikah</strong> for your journey to a <strong>blessed marriage</strong>—where <strong>sacred bonds</strong> are formed through <strong>shared values</strong> and <strong>spiritual purpose</strong> for <strong>harmonious lifelong unions</strong>."
            </Typography>

            {/* Call to Action */}
            <Box sx={{ textAlign: 'center', mt: 6 }}>
              <Button
                href="/profiles"
                variant="outlined"  // or "outlined" or "text" or "contained"
                color="primary"
                size="large"
                endIcon={<SearchIcon />}
              >
                Browse Verified Profiles
              </Button>
            </Box>

            {/* Trust Information */}
            <Box sx={{ textAlign: 'center', mt: 4, pt: 3, borderTop: 1, borderColor: 'divider' }}>
              <Typography variant="body2" color="text.secondary">
                An initiative of <strong>Carvan-e-Islam</strong><br />
                Serving the community with sincerity and trust
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
}

export default AboutUs;